import { render, staticRenderFns } from "./JobsMonitorPagesView.vue?vue&type=template&id=8f56a46c&scoped=true&"
import script from "./JobsMonitorPagesView.vue?vue&type=script&lang=js&"
export * from "./JobsMonitorPagesView.vue?vue&type=script&lang=js&"
import style0 from "./JobsMonitorPagesView.vue?vue&type=style&index=0&id=8f56a46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f56a46c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
